import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "HELOC",
        fields: [
            {
                // label: '',
                name: 'requested_amount',
                placeholder: '1000',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_100k_less__", "value": "100000"},
                    {"text": "__opt_100k_250k__", "value": "250000"},
                    {"text": "__opt_250k_500k__", "value": "500000"},
                    {"text": "__opt_500k_1m__", "value": "1000000"},
                    {"text": "__opt_1m_more__", "value": "1500000"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        // title: "Step 2",
        fields: [
            {
                label: '__property_value__',
                name: 'property_value',
                placeholder: '650000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                // hideIfCondition: (app) => {
                //     return fieldConditionHelper.homeOwner(app);
                // },
            },
        ],
        // hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        // title: "Step 3",
        fields: [
            {
                label: '__property_mortgage__',
                name: 'property_mortgage',
                placeholder: '300000',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                as: 'input',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 7
                },
                hideIfHasValue: true,
                // hideIfCondition: (app) => {
                //     return fieldConditionHelper.homeOwner(app);
                // },
            },
        ],
        // hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: 'executeSubmitApplication',
        title: "__what_province__",
        fields: [
            {
                name: 'state',
                type: 'select',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"value":"AB", "text":"ALBERTA"},
                    {"value":"BC", "text":"BRITISH COLUMBIA"},
                    {"value":"MB", "text":"MANITOBA"},
                    {"value":"NB", "text":"NEW BRUNSWICK"},
                    {"value":"NL", "text":"NEWFOUNDLAND AND LABRADOR"},
                    {"value":"NS", "text":"NOVA SCOTIA"},
                    {"value":"ON", "text":"ONTARIO"},
                    {"value":"PE", "text":"PRINCE EDWARD ISLAND"},
                    {"value":"QC", "text":"QUEBEC"},
                    {"value":"SK", "text":"SASKATCHEWAN"},
                    {"value":"NT", "text":"NORTHWEST TERRITORIES"},
                    {"value":"NU", "text":"NUNAVUT"},
                    {"value":"YT", "text":"YUKON"},
                ],
                hideIfHasValue: true,
            },
        ],
        // hideButtonsSection: true,
    },
];

export default steps;
